import { renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withModifiers as _withModifiers, createBlock as _createBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "_flex" }
const _hoisted_2 = { class: "_flex _gap-1" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_icon_base_button = _resolveComponent("icon-base-button")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _renderSlot(_ctx.$slots, "default", {
      onEdit: $options.onEdit,
      onSave: $options.onSave,
      onCancel: $options.onCancel,
      isEditing: _ctx.isEditing
    }),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.actions, ({ key, theme, shape, icon, onlyIcon, action }) => {
        return (_openBlock(), _createBlock(_component_icon_base_button, {
          key: key,
          theme: theme,
          shape: shape,
          icon: icon,
          "only-icon": onlyIcon,
          onClick: _withModifiers(action, ["prevent"]),
          "data-qa": `field-action:${key}`
        }, null, 8 /* PROPS */, ["theme", "shape", "icon", "only-icon", "onClick", "data-qa"]))
      }), 128 /* KEYED_FRAGMENT */))
    ])
  ]))
}